import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { css } from 'emotion';
import theme from '../../theme/theme';
import { useGlobalContext } from '../../context';
import { useEffect } from 'react';
import Select from 'react-select';

const ProfileList = ({ history, location }) => {
  function useQuery() {
    return new URLSearchParams(location.search);
  }

  const setOptions = (list) => {
    const options = list.map((e) => {
      const obj = {};
      obj.value = e._id;
      obj.label = e.name;
      return obj;
    });
    return options;
  };

  const query = useQuery();

  const {
    profiles: { profiles, getProfiles, searchProfiles },
    categories: { categories, getCategories },
  } = useGlobalContext();

  const [searchTerm, setSearchTerm] = useState(query.get('q') || '');

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    if (!categories) getCategories();
    const params = {
      select: 'image status categories name',
      populate: 'categories',
    };

    if (query.get('categories') && categories) {
      const list = categories.filter((e) =>
        query.get('categories').split(' ').includes(e._id)
      );
      setSelectedCategories(setOptions(list));
      params.categories = {
        in: query.get('categories').split(' '),
      };
    }

    if (query.get('q')) {
      searchProfiles(query.get('q'), params);
    } else if (!profiles || !query.get('q')) {
      getProfiles(params);
    }
  }, [location.search, categories]);

  const styles = {
    button: css({
      padding: '6px 18px',
      color: '#fff',
      backgroundColor: theme.colors.primary,
      borderRadius: 12,
    }),
    headerContainer: css({
      display: 'flex',
      justifyContent: 'end',
      maxWidth: 250,
      '& h3': {
        color: theme.colors.primary,
        marginLeft: 0,
      },
      '& > *': {
        marginLeft: 18,
      },
    }),
    imgWrapper: css({
      maxWidth: 36,
      borderRadius: '50%',
      maxHeight: 36,
      overflow: 'hidden',
      display: 'inline-block',
    }),
    img: css({
      maxWidth: '100%',
    }),
    tr: css({
      cursor: 'pointer',
      transition: '0.2s',
      '&:hover': {
        backgroundColor: '#ddd',
      },
    }),
  };

  return (
    <div>
      <Link to='/profiles/new' className={`float-right btn  ${styles.button}`}>
        ADD NEW
      </Link>
      <div className={`${styles.headerContainer} mt-3`}>
        <h3>Profiles</h3>

        <a
          href='#!'
          className='disabled'
          onClick={(e) => {
            e.preventDefault();
            setShowFilters(!showFilters);
          }}
        >
          {showFilters ? 'Hide filters' : 'Show filters'}
        </a>
      </div>
      {showFilters && (
        <>
          <div className='form-group'>
            <input
              type='search'
              className='form-control'
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                history.push('/profiles?q=' + e.target.value);
              }}
              placeholder='Search profiles'
              aria-describedby='emailHelp'
            />
          </div>
          <div>
            {categories && (
              <Select
                defaultValue={selectedCategories}
                isMulti
                name='colors'
                placeholder='Filter by category'
                options={setOptions(categories)}
                onChange={(val) => {
                  if (val?.length < categories.length || isNaN(val?.length)) {
                    let str = '';
                    if (!val?.length) {
                      query.delete('categories');
                    } else {
                      val.map((e) => {
                        str += e.value + ' ';
                      });
                      if (str.endsWith(' ')) {
                        str = str.slice(0, -1);
                      }
                      query.set('categories', str);
                    }
                    history.push('/profiles?' + query.toString());
                  }
                }}
              />
            )}
          </div>
        </>
      )}

      <table className='table'>
        <thead>
          <tr>
            <th scope='col'></th>
            <th scope='col'>Name</th>
            <th scope='col'>Status</th>
            <th scope='col'>Category</th>
          </tr>
          {profiles &&
            Array.isArray(profiles) &&
            profiles.map((profile, i) => (
              <tr
                key={i}
                onClick={() => history.push('/profiles/' + profile._id)}
                className={styles.tr}
              >
                <td>
                  <div className={styles.imgWrapper}>
                    <img
                      src={profile.image}
                      className={`${styles.img}`}
                      alt=''
                    />
                  </div>
                </td>
                <td>{profile.name}</td>
                <td>{profile.status}</td>
                <td>{profile.categories?.[0]?.name}</td>
              </tr>
            ))}
        </thead>
        <tbody></tbody>
      </table>
    </div>
  );
};

export default withRouter(ProfileList);
